import { render, staticRenderFns } from "./EditProvider.vue?vue&type=template&id=5ec7638c"
import script from "./EditProvider.vue?vue&type=script&lang=js"
export * from "./EditProvider.vue?vue&type=script&lang=js"
import style0 from "./EditProvider.vue?vue&type=style&index=0&id=5ec7638c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports